<template>
    <div>
        <Pane />

        <a-card class="container">
            <a-form
                    :form="form"
                    :label-col="{ span: 8 }"
                    :wrapper-col="{ span: 12 }"
                    :colon="false"
                    @submit="handleSubmit"
            >
                <a-row>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item>
                            <span class="required" slot="label">主要负责人</span>
                            <div>
                                <EmployeeSelector
                                        @change="chargerChange"
                                        :value="chargeUser.name ? [chargeUser] : []"
                                >
                                    <a-button block style="text-align: left">
                                        <div v-if="chargeUser.name">{{ chargeUser.name }}</div>
                                        <div v-else>&nbsp;</div>
                                    </a-button>
                                </EmployeeSelector>
                            </div>
                        </a-form-item>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item label="所属部门">
                            <a-select
                                    :disabled='true'
                                    show-search
                                    :filter-option="$selectFilterOption"
                                    v-decorator="[
                  'deptId',
                ]"
                                    style="width: 100%"
                                    placeholder
                            >
                                <a-select-option
                                        v-for="item in organizationList"
                                        :key="item.id"
                                        :value="item.id"
                                >
                                    {{
                                    item.uniqueName }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :lg="24" :md="24" :sm="24">
                        <a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                            <span class="required" slot="label">客户名称</span>
                            <CompanySelector @change="companyChange" :saveCompany="true" @nameSave="nameSave">
                                <a-button
                                        block
                                        style="margin-top: 4px; text-align: left"
                                        class="ellipsis"
                                >{{ selectedCompany.name }}</a-button>
                            </CompanySelector>
                        </a-form-item>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item label="业务类型">
                            <a-select
                                    v-decorator="[
                  'businessType',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
                                    style="width: 100%"
                                    placeholder="请选择"
                            >
                                <a-select-option
                                        v-for="item in customer_business_type_list"
                                        :key="item.dictCode"
                                        :value="item.dictLabel"
                                >
                                    {{ item.dictLabel }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item label="所属地市">
                            <a-cascader
                                    @change="locationChange"
                                    placeholder
                                    v-decorator="[
                  'location',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
                                    :options="cityList"
                                    :fieldNames="{
                  label: 'name',
                  value: 'name',
                  children: 'children',
                }"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item>
                            <span slot="label">所属区域</span>
                            <a-cascader
                                popup-class-name="area-cascader"
                                    placeholder=""
                                    v-decorator="[
                  'area',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
                                    :options="areaList"
                                    :fieldNames="{
                  label: 'areaName',
                  value: 'key',
                  children: 'children',
                }"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item label="经营属性">
                            <a-select
                                    v-decorator="[
                  'businessProperty',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
                                    style="width: 100%"
                                    placeholder="请选择"
                            >
                                <a-select-option
                                        v-for="item in business_property_list"
                                        :key="item.dictCode"
                                        :value="item.dictLabel"
                                >
                                    {{ item.dictLabel }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item label="客户业态">
                            <a-select
                                    v-decorator="[
                  'profession',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
                                    style="width: 100%"
                                    placeholder="请选择"
                            >
                                <a-select-option
                                        v-for="item in customer_profession_list"
                                        :key="item.dictCode"
                                        :value="item.dictLabel"
                                >
                                    {{ item.dictLabel }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item label="企业性质">
                            <a-cascader
                                    placeholder
                                    v-decorator="[
                  'customerNature',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
                                    :options="customer_nature_list"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item label="联系人姓名">
                            <a-input
                                    v-decorator="[
                  'contact.name',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
                                    placeholder="请输入"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item label="联系人部门">
                            <a-select
                                    v-decorator="[
                  'contact.apartment',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
                                    style="width: 100%"
                                    placeholder="请选择"
                            >
                                <a-select-option
                                        v-for="item in contact_dept_list"
                                        :key="item.dictCode"
                                        :value="item.dictLabel"
                                >
                                    {{ item.dictLabel }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item label="联系人职务">
                            <a-input
                                    v-decorator="[
                  'contact.position',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
                                    placeholder="请输入"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item label="联系人手机">
                            <a-input
                                    v-decorator="[
                  'contact.mobile',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
                                    placeholder="请输入"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item label="业务决策人">
                            <a-radio-group
                                    v-decorator="[
                  'contact.isDecisionMaker',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
                            >
                                <a-radio :value="0">否</a-radio>
                                <a-radio :value="1">是</a-radio>
                            </a-radio-group>
                        </a-form-item>
                    </a-col>
                    <a-col :lg="24" :md="24" :sm="24">
                        <a-form-item label="客户关系" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                            <a-checkbox-group
                                    v-decorator="[
                  'customerRelationship',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
                            >
                                <a-checkbox
                                        v-for="item in ['高层互访','中层资源', '基层对接']"
                                        :key="item"
                                        :value="item"
                                >
                                    {{ item }}
                                </a-checkbox>
                            </a-checkbox-group>
                        </a-form-item>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item>
                            <span slot="label" class>互访带队领导</span>
                            <div>
                                <EmployeeSelector
                                        @change="(arr) => {
                      if (arr.length) {
                        visitLeader = arr[0];
                      } else {
                        visitLeader = {};
                      }
                    }
                      "
                                        :value="visitLeader.name ? [visitLeader] : []"
                                >
                                    <a-button block style="text-align: left">
                                        <div v-if="visitLeader.name">{{ visitLeader.name }}</div>
                                        <div v-else>&nbsp;</div>
                                    </a-button>
                                </EmployeeSelector>
                            </div>
                        </a-form-item>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item label="互访日期">
                            <a-date-picker
                                    placeholder=""
                                    v-decorator="[
                  'visitDate',
                ]"
                                    style="width: 100%"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item label="一级细分">
                            <a-select
                                    v-decorator="[
                  'firstSubdivision',
                ]"
                                    style="width: 100%"
                                    placeholder="请选择"
                            >
                                <a-select-option
                                        v-for="item in first_subdivision_list"
                                        :key="item.dictCode"
                                        :value="item.dictLabel"
                                >
                                    {{ item.dictLabel }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :lg="24" :md="24" :sm="24">
                        <a-form-item label="潜在项目线索说明：" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                            <a-textarea
                                    v-decorator="[
                  'remark',
                ]"
                            />
                        </a-form-item>
                    </a-col>
                </a-row>
                <div class="center">
                    <a-space>
                        <a-button @click="$close($route.path)">关闭</a-button>
                        <a-button type="primary" html-type="submit" :loading="saveLoading">提交</a-button>
                    </a-space>
                </div>
                <!-- 把你原来的区域分布 替换成这段 -->
                <div class="region-desc">
                    <div class="title">区域分布：</div>
                    <div class="item">
                        <span>经营一组（杨小平）：</span>
                        <p>集团总部；南京【玄武区、秦淮区、建邺区、鼓楼区、栖霞区、雨花台区、江宁区、溧水区、高淳区、江北新区】；泰州【市本级、海陵区、高港区、姜堰区】。</p>
                    </div>
                    <div class="item">
                        <span>经营二组（燕强）：</span>
                        <p>集团西部大区、集团东部大区、集团南部大区；无锡【锡山区、滨湖区】；盐城【滨海县、阜宁县】。</p>
                    </div>
                    <div class="item">
                        <span>经营三组（任云）：</span>
                        <p>苏州【常熟市、张家港市、昆山市】；南通【通州区】；连云港【灌南县】；淮安【市本级、淮安区、盱眙县、金湖县】；盐城【射阳县、建湖县】；扬州【宝应县】；镇江【句容市】；泰州【兴化市、靖江市、泰兴市】；宿迁【宿城区、泗洪县】。</p>
                    </div>
                    <div class="item">
                        <span>经营四组（王威）：</span>
                        <p>省环保产业股份有限公司、湖北黄冈；徐州【睢宁县】；连云港【东海县】；淮安【涟水县】；镇江【丹阳市】。</p>
                    </div>
                    <div class="item">
                        <span>经营五组（沈巍）：</span>
                        <p>南京【市本级】；无锡【惠山区、梁溪区、江阴市、宜兴市】；徐州【鼓楼区、贾汪区、泉山区、丰县、沛县、邳州市】；苏州【相城区、吴江区、太仓市】；连云港【市本级、海州区、赣榆区、灌云县】；盐城【响水县】；扬州【市本级、仪征市】；镇江【市本级、京口区、润州区】；宿迁【市本级】。</p>
                    </div>
                    <div class="item">
                        <span>经营六组（孙鹏）：</span>
                        <p>海外、集团北部大区；徐州【市本级】。</p>
                    </div>
                    <div class="item">
                        <span>经营七组（袁忠伟）：</span>
                        <p>葛洲坝集团、江苏省环保集团（产业公司除外）；常州【市本级、溧阳市】；南通【市本级、崇川区、海门区、如东县、启东市、如皋市、海安市】；淮安【淮阴区、洪泽区】；盐城【市本级、亭湖区、盐都区、大丰区、东台市】；扬州【高邮市】；镇江【丹徒区】；宿迁【宿豫区、泗阳县、开发区】。</p>
                    </div>
                    <div class="item">
                        <span>经营八组（黄晓东）：</span>
                        <p>安徽池州、安徽宿州；南京【六合区】。</p>
                    </div>
                </div>
            </a-form>
        </a-card>
    </div>
</template>

<script>
import city from "@/mixins/cityScrm";
import area from "@/mixins/area";
import organization from "@/mixins/organization";
import watermark from "@/mixins/watermark";

import { mapGetters } from "vuex";

import EmployeeSelector from "@/components/employee-selector";
import CompanySelector from "@/components/company-selector-all";

import accurate from "accurate";

import request from "@/api/request";

export function fetchCity() {
    return request({
        url: '/market-service/scrm/company/address',
        method: 'post',
    })
}
function add(data) {
    return request({
        url: "/market-service/scrm/channel/add",
        method: "post",
        data
    });
}
function update(data) {
    return request({
        url: "/market-service/scrm/channel/updateForReview",
        method: "post",
        data
    });
}
function getDict() {
    return request({
        url: "https://scrm.njszy.com/api/crm/system/dict/data/batchDictType/customer_level,business_property,customer_profession,first_subdivision,customer_status,customer_valid_status,customer_business_type,contact_dept",
    });
}
function getCustomerNature() {
    return request({
        url: "https://scrm.njszy.com/api/crm/system/config/configKey/customer_nature",
    });
}
function getDetail(id) {
    return request({
        url: "/market-service/scrm/channel/query/" + id,
        method: "post",
    });
}
export function fetchCompanyAddress(data) {
    return request({
        url: '/market-service/scrm/company/getAddressInfo',
        method: 'POST',
        data
    })
}
export default {
    mixins: [area, city, organization, watermark],

    components: {
        EmployeeSelector,
        CompanySelector
    },

    data() {
        return {
            form: this.$form.createForm(this),
            selectedUser: {},
            selectedCompany: {},
            saveLoading: false,
            chargeUser: {},
            businessUser: {},
            technologyUser: {},
            visitLeader: {},
            belongProvince: '',
            belongCity: '',
            district: '',
            deptId: '',
            first_subdivision_list: [],
            customer_business_type_list: [],
            business_property_list: [],
            customer_profession_list: [],
            customer_nature_list: [],
            contact_dept_list: [],
            ifEdit: false,
        };
    },

    computed: {
        ...mapGetters("setting", ["findDataDict"]),

        phaseList() {
            return this.findDataDict("phase");
        },
        signStatusList() {
            return this.findDataDict("contractSignStatus");
        },

        majorList() {
            return this.findDataDict("contract_scale");
        }
    },
    mounted() {
        const id = this.$route.query.id;
        if(id){
            this.ifEdit = true;
            getDetail(id).then(res => {
                const area = [];
                if (res.areaId) {
                    area.push(res.areaId);
                }
                if (res.subAreaId) {
                    area.push(res.subAreaId);
                }
                if (res.l3AreaId) {
                    area.push(res.l3AreaId);
                }

                this.form.setFieldsValue({
                    ...res,
                    customerRelationship: res.customerRelationship.split(","),
                    location: [res.belongProvince, res.belongCity, res.district],
                    area: area,
                });
                this.deptId = res.deptId;
                this.belongProvince = res.belongProvince;
                this.belongCity = res.belongCity;
                this.district = res.district;
                this.chargeUser = {
                    name: res.chargeUserName,
                    userId: res.chargeUserId
                };
                this.visitLeader = {
                    name: res.visitLeaderName,
                    userId: res.visitLeaderId
                };
                this.selectedCompany = {
                    name: res.customerName,
                };
                const customerNature = res.customerNature
                getCustomerNature().then(res => {
                    const data = JSON.parse(res)
                    console.log(data)
                    data.forEach(item => {
                        if(item.label === customerNature){
                            this.form.setFieldsValue({
                                customerNature: [item.label]
                            })
                        }else if(item.children){
                            item.children.forEach(citem => {
                                if(citem.label === customerNature){
                                    this.form.setFieldsValue({
                                        customerNature: [item.label, citem.label]
                                    })
                                }
                            })
                        }
                    })
                })
            })
        }
        getDict().then(res => {
            this.first_subdivision_list = res.find(item => item.dicType === "first_subdivision").dictDatas
            this.customer_business_type_list = res.find(item => item.dicType === "customer_business_type").dictDatas
            this.business_property_list = res.find(item => item.dicType === "business_property").dictDatas
            this.customer_profession_list = res.find(item => item.dicType === "customer_profession").dictDatas
            this.contact_dept_list = res.find(item => item.dicType === "contact_dept").dictDatas
        })
        getCustomerNature().then(res => {
            this.customer_nature_list = JSON.parse(res)
        })
    },
    methods: {
        nameSave(name){
            this.selectedCompany = {
                name: name
            }
        },
        companyChange(company) {
            console.log(company)
            this.selectedCompany = company
            fetchCompanyAddress({
                creditCode: company.creditCode
            }).then(res => {
                this.belongCity = res.city
                this.district = res.district

                fetchCity().then(res => {
                    if (Array.isArray(res)) {
                        const province = res.filter(item => !item.pid)
                        console.log(res.find(item => item.name === this.belongCity))
                        const pid = res.find(item => item.name === this.belongCity).pid
                        const pp = province.find(item => item.id == pid)
                        console.log(pp.name)
                        this.belongProvince = pp.name
                        this.form.setFieldsValue({
                            location: [this.belongProvince, this.belongCity, this.district]
                        })
                    }
                })

            })
        },
        chargerChange(arr) {
            console.log(arr)
            if (arr.length) {
                this.chargeUser = arr[0];
                this.form.setFieldsValue({
                    deptId: arr[0].deptId
                });
                this.deptId = arr[0].deptId
            }else {
                this.chargeUser = {};
            }

        },
        locationChange(arr){
            this.belongProvince = arr[0];
            this.belongCity = arr[1];
            this.district = arr[2];
        },
        handleSubmit(e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (!err) {
                    if (!this.chargeUser.userId) {
                        this.$message.error("请选择主要负责人");
                        return;
                    }
                    this.save(values);
                }
            });
        },

        save(values) {
            this.saveLoading = true;

            let area1 = {};
            let area2 = {};
            let area3 = {};

            if (Array.isArray(values.area)) {
                const [areaId1, areaId2, areaId3] = values.area;
                area1 = this.rawAreaList.find((item) => item.id === areaId1);
                area2 = this.rawAreaList.find((item) => item.id === areaId2);
                area3 = this.rawAreaList.find((item) => item.id === areaId3);
            }

            if(this.ifEdit){
                update({
                    ...values,
                    areaId: area1?.id,
                    areaName: area1?.areaName,
                    subAreaId: area2?.id,
                    subAreaName: area2?.areaName,
                    l3AreaId: area3?.id,
                    l3AreaName: area3?.areaName,
                    belongProvince:this.belongProvince,
                    belongCity:this.belongCity,
                    district:this.district,
                    customerRelationship: values.customerRelationship ? values.customerRelationship.join(",") : '',
                    deptName: this.organizationList.find(
                        item => item.id === values.deptId
                    )?.uniqueName,
                    chargeUserId: this.chargeUser.userId,
                    chargeUserName: this.chargeUser.name,
                    visitLeaderId: this.visitLeader.userId,
                    visitLeaderName: this.visitLeader.name,
                    customerName: this.selectedCompany.name,
                    customerNature: values.customerNature[values.customerNature.length - 1],
                    id: this.$route.query.id
                })
                    .then(() => {
                        this.$close(this.$route.path);
                    })
                    .finally(() => {
                        this.saveLoading = false;
                    });
            }else{
                add({
                    ...values,
                    areaId: area1?.id,
                    areaName: area1?.areaName,
                    subAreaId: area2?.id,
                    subAreaName: area2?.areaName,
                    l3AreaId: area3?.id,
                    l3AreaName: area3?.areaName,
                    belongProvince:this.belongProvince,
                    belongCity:this.belongCity,
                    district:this.district,
                    customerRelationship: values.customerRelationship ? values.customerRelationship.join(",") : '',
                    deptName: this.organizationList.find(
                        item => item.id === values.deptId
                    )?.uniqueName,
                    chargeUserId: this.chargeUser.userId,
                    chargeUserName: this.chargeUser.name,
                    visitLeaderId: this.visitLeader.userId,
                    visitLeaderName: this.visitLeader.name,
                    customerName: this.selectedCompany.name,
                    customerNature: values.customerNature[values.customerNature.length - 1]
                })
                    .then(() => {
                        this.$close(this.$route.path);
                    })
                    .finally(() => {
                        this.saveLoading = false;
                    });
            }
        }
    }
};
</script>
<style lang="less" scoped>
.container {
    padding-top: 24px;
}

.center {
    padding: 30px 0;
}

/* 级联选择器样式（你原来的） */
:global(.ant-cascader-menus.area-cascader) {
    .ant-cascader-menu {
        height: auto !important;
        max-height: unset !important;
        overflow: visible !important;
    }
}

/* 区域分布美化样式 */
.region-desc {
    padding: 16px 20px;
    background: #f9fafc;
    border-radius: 8px;
    border: 1px solid #e5e6eb;
    line-height: 1.7;
    width: 85%;
    margin:auto;
    .title {
        font-size: 15px;
        font-weight: bold;
        color: #333;
        margin-bottom: 12px;
    }

    .item {
        margin-bottom: 10px;
        display: flex;
        align-items: flex-start;

        span {
            min-width: 130px;
            font-weight: 500;
            color: #000;
            flex-shrink: 0;
        }

        p {
            margin: 0;
            color: #555;
            flex: 1;
        }
    }
}
</style>
